import React, { useState, useEffect } from 'react';
import {
    Checkbox,
    FormControlLabel,
    FormGroup,
    Tooltip,
    ListSubheader
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import MenuItem from '@material-ui/core/MenuItem';
import { FormProvider } from 'react-hook-form';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { getProjectDeskOn, getListProjectExternalDesk, getProjectById } from '@/service/projectService';
import FormInput from '@/component/common/form/input';
import Constant from '@/common/constant/Constant';
import LoadingPanel from '@/component/common/LoadingPanel';
import ButtonSubmitAddTicket from './ButtonSubmitAddTicket';
import { getFormFieldData } from '@/component/common/layout/addTicket/handler/AddTicketHandler';
import ErrorModal from '@/component/common/modal/ErrorModal';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import {
    initDataPanelCreateTicketEscalate,
    onSubmitCreateEscalateTicket,
    onSubmitSaveDraftEscalateTicket,
    initDataFromDrafTicket
} from '@/component/ticketList/handler/EscalateTicketHandler';

import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
    closePanelTabSelector,
    triggerReloadTicketListByPanelType,
    updatePanelAfterCreateTicketSelector,
    triggerReloadHelpdeskTicketByCreateEscalateTicket
} from '@/state/selector/panelSelector';
import {
    multiPanelAtom,
    panelStartIndexAtom,
    panelSettingAtom,
    reloadChatThreadPanelAtom,
    panelInitDataAtom,
    lastActivePanelIdAtom,
    closeTabId
} from '@/state/atom/panelAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { userAtom } from '@/state/atom/userAtom';
import Utils from '@/common/utils/utils';
import { isExChangeTicket } from '@/state/ticketState';
import RenderFieldUI from '../formManagement/RenderFieldUI';
import CustomSchema from '@/schema/CustomSchema';
import { getFormListByProject } from '@/service/formManagementService';
import {
    getFormFromFormListById,
    getListCustomFiledOfForm,
    sortListByOrder,
    unregisterField
} from './handler/TicketHandler';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { I18n } from 'aws-amplify';
import {
    checkIsDisableBtnSent,
    checkIsDisableButtonDraft,
    onSubmitDeleteDraftQaTicket,
} from './handler/QaTicketHandler';
import DataChangePleaseReloadModal from '@/component/common/modal/DataChangePleaseReloadModal';
import { TmpHiddenSysfieldInCreateTicket } from '../../common/constant/SystemField';
import { cloneDeep } from 'lodash';
import {
    getPanelInitData,
    updatePanelInitData
} from '@/component/multiPanel/panel/handler/PanelHandler';
import { checkDetailTicket, getTicketById } from '@/service/ticketService';
import { useSnackbar } from 'notistack';
import { DialogConfirmCancelCreateTicket } from '@/component/ticketList/addTicketDialog/DialogConfirmCancelCreateTicket';
import './EscalateTicket.css';
import { DialogConfirmChangeTicketError } from './addTicketDialog/DialogConfirmChangeTicketError';
import {showLoadingMouse, hideLoadingMouse} from '../../common/utils/CustomCursor';
import { helpdeskTicketLastUserActionAtom } from '@/state/atom/ticketAtom';
import { isDataInputUrlError } from './handler/KnowledgeTicketHandler';
import { openShareLinkTicket } from '../chatThread/handler/MessageHandler';
import {
    setPanelSelector
} from '@/state/selector/panelSelector';

// isAtTicketDetail, API, userDetail, listProjectDeskOn
export default function EscalateTicket(props) {
    const MAIL_TICKET_TYPES = [Constant.TICKET_TYPE.EMAIL, Constant.TICKET_TYPE.EMAIL_REPLY]
    const { enqueueSnackbar } = useSnackbar();
    // Get common state for close panel when add ticket done
    const panelChildren = window.innerWidth > 991 ? 3 : 1;
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [currentIndex, setCurrentIndex] = useRecoilState(panelStartIndexAtom);
    const [settingSlide, setSettingSlide] = useRecoilState(panelSettingAtom);

    // common userDetail state
    const [userDetail, setUserDetail] = useRecoilState(userAtom);

    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const [currentPanelInitData, setCurrentPanelInitData] = useState({});
    const lastActivePanelId = useRecoilValue(lastActivePanelIdAtom);

    const [reload, setReload] = useRecoilState(reloadChatThreadPanelAtom);
    const [exChangeTicket, setExchangeTicket] = useRecoilState(isExChangeTicket);

    const [isLoading, setIsLoading] = useState(false);
    const [listProjectDeskOn, setListProjectDeskOn] = useState([]);
    const [corporationTarget, setCorporationTarget] = useState('');
    const [projectTarget, setProjectTarget] = useState('');
    const [fileUploadList, setFileUploadList] = useState([]);
    const [fieldListData, setFiledListData] = useState([]);
    const corporationDetail = useRecoilValue(corporationAtom);
    const [projectDetail, setProjectDetail] = useRecoilState(projectInuseDetailAtom);
    const [listFieldEdited, setListFieldEdited] = useState([]);
    const [autoFillObject, setAutoFillObject] = useState({});
    const [onChangeEdit,setOnChangeEdit] = useState(false);

    const validateCreateEscalateTicket = useForm({
        mode: 'all',
        resolver: yupResolver(CustomSchema(fieldListData))
    });
    const handleSubmitCreateEscalateTicket = validateCreateEscalateTicket.handleSubmit;
    const errorCreateEscalateTicket = validateCreateEscalateTicket.errors;
    const clearErrors = validateCreateEscalateTicket.clearErrors;
    const setValueCreateEscalateTicket = validateCreateEscalateTicket.setValue;
    const registerCreateEscalateTicket = validateCreateEscalateTicket.register;
    const unregisterCreateEscalateTicket = validateCreateEscalateTicket.unregister;
    const setErorsCreateEscalateTicket = validateCreateEscalateTicket.setError;
    const getValueEscalateTicket = validateCreateEscalateTicket.getValues;
    const [isEdited, setIsEdited] = useState(false);

    const [formList, setFormList] = useState([]);
    const [selectedForm, setSelectedForm] = useState('');
    const [selectedFormInfo, setSelectedFormInfo] = useState({});
    const [isDisableButtonDraft, setIsDisableButtonDraft] = useState(true);
    const [isDisableButtonSent, setIsDisableButtonSent] = useState(true);
    const [isExChangeTagField, setIsExChangeTagField] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [isEnableShareCustomerThread, setIsEnableShareCustomerThread] = useState(false);
    const [isEnableShareTicketParent, setIsEnableShareTicketParent] = useState(false);
    const [ticketDetail, setTicketDetail] = useState({});

    const [isModalUploadFileError, setIsModalUploadFileError] = useState(false);
    const [fileUploading, setFileUploading] = useState({});

    const [internalHelpDeskList, setInternalHelpDeskList] = useState([]);
    const [externalHelpDeskList, setExternalHelpDeskList] = useState([]);

    const closePanelTab = useSetRecoilState(closePanelTabSelector);

    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [isOpenSelectProject, setIsOpenSelectProject] = useState(false);

    const [confirmDialogObj, setConfirmDialogObj] = useState({open: false, msg: '', targetId: '', type: ''});
    const [isOpenSelectForm, setIsOpenSelectForm] = useState(false);
    
    // Cancel create ticket
    const [isConfirmCancelCreateTicket, setIsConfirmCancelCreateTicket] = useState(false);

    const [draftModeData, setDraftModeData] = useState({isDraftMode: false, firstTimeUpdate: false});
    const [confirmDialog, setConfirmDialog] = useState({open: false, msg: ''});
    const [isOpenPopupError, setIsOpenPopupError] = useState(false);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);
    const reloadHelpdeskTicketByCreateEscalateTicket = useSetRecoilState(triggerReloadHelpdeskTicketByCreateEscalateTicket);
    const [fileUpdatedList, setFileUpdatedList] = useState([]);
    const draftTicketData = props?.draftData;
    const ticketIdSelected = draftTicketData ? draftTicketData.detailTicket.parent : props.ticketId;
    const isDraftMode = Utils.isEmptyObject(draftTicketData) ? false : true;
    const [lastUserAction, setLastUserAction] = useRecoilState(helpdeskTicketLastUserActionAtom);
    
    const addNewPanel = useSetRecoilState(setPanelSelector);
    
    const [isOpenPopupKnowledgeOff, setIsOpenPopupKnowledgeOff] = useState(false);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [isOpenNotFoundTicketPopup,setIsOpenNotFoundTicketPopup] = useState(false);
    const [showPopupSingleButtonError, setShowPopupSingleButtonError] = useState({
        isShow: false,
        message: I18n.get('MSG-CM-DELETED-CONTENT'),
        confirmTxt: I18n.get('CM-BUTTON-OK')
    });

    const onClickUrlViewTicket = async (url) => {
        setIsLoading(true)
        const {
            orgDomain: affiliationOrganizationDomain,
            projectId: affiliationProject,
            ticketId: ticketIdOfUrl,
            withMessage
        } = await Utils.extractShareLinkInfo(url);

        await openShareLinkTicket(
            props?.API,
            ticketIdOfUrl,
            affiliationProject,
            affiliationOrganizationDomain,
            userDetail.id,
            projectDetail.id,
            {
                ...props,
                setIsLoading,
                API: props?.API,
                setIsOpenAccessDeniedPopup,
                setIsOpenPopupKnowledgeOff,
                setIsOpenNotFoundTicketPopup,
                addNewPanel,
                setLastUserAction,
                setPanelList,
                setProjectDetail: setProjectDetail,
                userDetail: userDetail,
                setUserDetail: setUserDetail,
                setShowPopupSingleButtonError
            },
            withMessage
        );
    }

    //handle onChange form
    const handleOnchangeForm = async (targetForm, e = null) => {
        if (targetForm === selectedForm || typeof targetForm === "undefined") {
            return;
        }

        if (draftModeData.isDraftMode) {
            let ticketId = draftTicketData?.detailTicket?.id;
            let currentStatusTicket = await checkDetailTicket(props?.API, ticketId);
            if (currentStatusTicket.status === Constant.TICKET_DELETED_STATUS.REMOVED) {
                setIsOpenPopupError(true);
                return;
            }
        }

        if ((draftModeData.isDraftMode && draftModeData.firstTimeUpdate) || 
            (isEdited && selectedForm)
        ) {
            if (e) e.stopPropagation();
            // show modal confirm
            setConfirmDialogObj({
                open: true,
                msg: I18n.get('USER04MSG017'),
                targetId: targetForm,
                type: 'form'
            });
            setIsOpenSelectForm(false)
            return;
        }
       
        handleTargetForm(targetForm);
    };

    const handleTargetForm = async targetForm => {
        setIsLoading(true);
        setIsEdited(false);
        if (!Utils.isEmptyArray(fieldListData)) {
            unregisterField(fieldListData, unregisterCreateEscalateTicket);
        }
        setSelectedForm(targetForm);
        setCurrentPanelInitData({})
        setValueCreateEscalateTicket('selectedForm', targetForm);
        const selectedFormDetail = await getFormFromFormListById(targetForm);
        if (!Utils.isEmptyObject(selectedFormDetail)) {
            setSelectedFormInfo(selectedFormDetail);
            const formStructure = Utils.convertJSONDataToObject(selectedFormDetail?.structure);
            const customFieldList = await getListCustomFiledOfForm(
                formStructure,
                props?.API,
                selectedFormDetail.affiliationOrganization
            );
            let getFieldListResult = getFormFieldData(formStructure, customFieldList);
            getFieldListResult = getFieldListResult.filter(
                x => Number(x.structure.publicForCustomer) !== 1 || x.type === 'WORKFLOW'
            );
            getFieldListResult = Array.from(getFieldListResult, field => {
                if (Number(field.structure.publicForCustomer) === 2) {
                    field.structure.required = false;
                }
                return field;
            });

            getFieldListResult = getFieldListResult.filter(x => {
                if ((x.definition = Constant.FORM_DEFINITION.SYSTEM)) {
                    return true;
                }
                if (x.affiliationOrganization === corporationTarget) {
                    return true;
                }
                if (corporationTarget) {
                    let shareRangeOfField = Utils.convertJSONDataToObject(x.shareRange)
                        ? []
                        : Utils.convertJSONDataToObject(x.shareRange);
                    return shareRangeOfField?.includes(corporationTarget);
                }
                return true;
            });

            // Sort by form setting
            let fieldOrderInForm = {};
            if (!Utils.isEmptyObject(formStructure)) {
                for (const [structureKey, structureValue] of Object.entries(formStructure)) {
                    if (structureKey && structureValue && structureValue.hasOwnProperty('field')) {
                        fieldOrderInForm[structureValue['field']] = parseInt(structureKey);
                    }
                }
            }
            getFieldListResult = getFieldListResult
                .filter(
                    field =>
                        !field.sysField || !TmpHiddenSysfieldInCreateTicket.includes(field.sysField)
                )
                .sort((a, b) => {
                    if (!a.order || !b.order) return 1;
                    // attachment always at bottom
                    if (a.sysField === 'attachments') return 1;
                    if (b.sysField === 'attachments') return -1;
                    if (!Utils.isEmptyObject(fieldOrderInForm)) {
                        return fieldOrderInForm[a.id] - fieldOrderInForm[b.id];
                    }
                    return 1;
                });
            
            setFiledListData([...getFieldListResult]);  
        }
        setIsLoading(false);
    };

    const argsAll = {
        isDraft: props?.isDraft,
        API: props?.API,
        panelId: props.panelId,
        panelType: props.panelType,
        tabId: props.tabId,
        userDetail,
        
        panelChildren,
        panelList,
        currentIndex,
        settingSlide,
        panelInitData,
        setPanelInitData,
        currentPanelInitData,

        setPanelListRecoilState: setPanelList,
        setCurrentIndex,
        setSettingSlide,
        projectTarget,
        setProjectTarget,
        formList,
        setFormList,
        selectedForm,
        setSelectedForm,
        selectedFormInfo,
        setSelectedFormInfo,
        setIsLoading,
        fileUploading,
        setFileUploading: setFileUploading,
        isModalUploadFileError,
        setIsModalUploadFileError,
        setReload: setReload,
        reload: reload,
        exChangeTicket: exChangeTicket,
        setExchangeTicket: setExchangeTicket,
        setIsDisableButtonDraft: setIsDisableButtonDraft,
        customerThread: ticketDetail.chatThreadWithCustomer,
        internalThread: ticketDetail.chatThreadInProject,
        ticketIdSelected: ticketIdSelected,
        ticketDetail,
        corporationDetail: corporationDetail,
        fieldListData: fieldListData,
        setFiledListData,
        createTicketType: Constant.TICKET_TYPE.ESCALATION,
        updatePanelAfterCreateTicket: useSetRecoilState(updatePanelAfterCreateTicketSelector),
        getValuesCreateQaTicket: getValueEscalateTicket,
        isOpenModalReloadPage,
        setIsOpenModalReloadPage,

        listProjectDeskOn,
        setListProjectDeskOn,
        corporationTarget,
        setCorporationTarget,
        setValueCreateEscalateTicket,
        isEnableShareCustomerThread,
        setIsEnableShareCustomerThread,
        isEnableShareTicketParent,
        setIsEnableShareTicketParent,
        enqueueSnackbar,
        closePanelTab, 

        handleOnchangeForm,
        setCurrentPanelInitData,
        draftTicketData,
        isConfirmCancelCreateTicket,
        setIsConfirmCancelCreateTicket,
        isDraftMode,
        isEdited,
        isOpenSelectForm, 
        setIsOpenSelectForm,
        isOpenPopupError,
        setIsOpenPopupError,
        reloadTicketListByPanelType,
        reloadHelpdeskTicketByCreateEscalateTicket,
        fileUpdatedList,
        setFileUpdatedList,
        fileUploadList,
        projectDetail,
        setLastUserAction,
        setUserDetail
    };

    useEffect(() => {
        updatePanelInitData(
            props.panelId,
            props.tabId,
            panelInitData,
            setPanelInitData,
            'isEditedData',
            isEdited
        );
    }, [isEdited]);

    useEffect(() => {
        if (isLoading) {
            return showLoadingMouse();
        } 
        return hideLoadingMouse();
    
     }, [isLoading]);

    useEffect(() => {
        registerCreateEscalateTicket('corporationTarget');
        registerCreateEscalateTicket('projectTarget');
        registerCreateEscalateTicket('fileUploadList');
        registerCreateEscalateTicket('selectedForm');

        setIsLoading(true);
        getTicketById(props?.API, ticketIdSelected).then(ticketDetailResult => {
            if (!ticketDetailResult || Utils.isEmptyArray(ticketDetailResult)) return;

            setTicketDetail(ticketDetailResult);
        });

        let currentPanelInitDataRes = getPanelInitData(props.panelId, props.tabId, panelInitData);

        if (draftTicketData && Utils.isEmptyObject(currentPanelInitDataRes)) {
            setIsLoading(true);
        }

        if (currentPanelInitDataRes && !Utils.isEmptyObject(currentPanelInitDataRes)) {
            setCurrentPanelInitData(currentPanelInitDataRes);
            if (currentPanelInitDataRes.formData) {
                let fileUploadListOld = currentPanelInitDataRes.formData.fileUploadList;
                if (!Utils.isEmptyArray(fileUploadListOld)) {
                    setFileUploadList(fileUploadListOld);
                    setValueCreateEscalateTicket('fileUploadList', fileUploadListOld);
                }
            }
            if (currentPanelInitDataRes.argsAll) {
                setIsLoading(true);
                initDataPanelCreateTicketEscalate(currentPanelInitDataRes, argsAll);
                setIsLoading(false);
                // return;
            }
        }

        // escalation ticket
        getProjectDeskOn(props?.API, corporationDetail.id)
            .then(async projectList => {
                let listInternalProjectDeskOn = [];
                for (const project of projectList) {
                    let projectTemp = { ...project };
                    projectTemp.name = Utils.getTextByLanguage(
                        Constant.LANGUAGE_TYPE.JP,
                        project.name
                    );
                    listInternalProjectDeskOn.push(projectTemp);
                }

                getListProjectExternalDesk(props?.API, projectDetail, true)
                    .then(async result => {
                        let listExternalDesk = [];
                        for (let project of result) {
                            if (
                                project?.corporationData?.deskService ===
                                Constant.STATUS_SERVICE_PERMISSION.OFF
                            ) {
                                continue;
                            }
                            project.name = `${Utils.getTextByLanguage(
                                Constant.LANGUAGE_TYPE.JP,
                                JSON.parse(project.name)
                            )} (${Utils.getTextByLanguage(
                                Constant.LANGUAGE_TYPE.JP,
                                JSON.parse(project.corporationData.name)
                            )})`;
                            listExternalDesk.push(project);
                        }

                        let listProjectDeskOnResult = [...listInternalProjectDeskOn, ...listExternalDesk];
                        setInternalHelpDeskList(listInternalProjectDeskOn);
                        setExternalHelpDeskList(listExternalDesk);
                        setListProjectDeskOn(listProjectDeskOnResult);
                        argsAll.draftListProjectDeskOn = listProjectDeskOnResult;

                        if (draftTicketData && Utils.isEmptyObject(currentPanelInitDataRes)) {
                            setDraftModeData({
                                isDraftMode: true,
                                firstTimeUpdate: true
                            })
                            initDataFromDrafTicket(argsAll);
                            // setIsLoading(false);
                        } else {
                            let workLastForm = Utils.convertJSONDataToObject(userDetail.workLastForm);
                            let lastFormOfProject = workLastForm[projectDetail.id];
                            if (lastFormOfProject && Utils.isEmptyString(currentPanelInitDataRes?.argsAll?.selectedForm)) {
                                setIsLoading(true);
                                await initDataLastForm(lastFormOfProject);
                            }
                            setIsLoading(false);
                        }

                    })
                    .catch(err => {
                        setListProjectDeskOn([]);
                        setIsLoading(false);
                    });
            })
            .catch(err => {
                setIsLoading(false);
                setListProjectDeskOn([]);
            });
    }, []);

    useEffect(() => {
        // Update panelInitDataAtom
        let newArgsAll = cloneDeep(argsAll);
        delete newArgsAll.panelInitData;
        updatePanelInitData(
            props.panelId,
            props.tabId,
            panelInitData,
            setPanelInitData,
            'argsAll',
            newArgsAll
        );
    }, [
        projectTarget,
        selectedForm,
        fieldListData,
        isEnableShareCustomerThread,
        isEnableShareTicketParent,
        fileUploadList
    ]);

    useEffect(() => {
        if (
            lastActivePanelId &&
            lastActivePanelId.panelId === props.panelId &&
            lastActivePanelId.tabId === props.tabId
        ) {
            let formData = getValueEscalateTicket();
            updatePanelInitData(
                props.panelId,
                props.tabId,
                panelInitData,
                setPanelInitData,
                'formData',
                formData
            );
        }
    }, [lastActivePanelId]);

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            if (isEdited) {
                setIsConfirmCancelCreateTicket(true);
            } else {
                let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
                if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
                closePanelTab({
                    event: null,
                    panelType: currentPanelInfo.type,
                    panelId: props.panelId,
                    tabId: props.tabId
                });
            }
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);


    const onClickCloseConfirmDialog = () => {
        setConfirmDialogObj({open: false, msg: '', targetId: '', })
    }

    const onClickOkConfirmDialog = async () => {
        const confirmDialogObjClone = {...confirmDialogObj};
        const targetId = confirmDialogObjClone.targetId;
        const type = confirmDialogObjClone.type;
        
        let draftModeDataClone = {...draftModeData};
        draftModeDataClone.firstTimeUpdate = false;
    
        setDraftModeData(draftModeDataClone)
        
        setConfirmDialogObj({open: false, msg: '', targetId: '', type: ''})
        if (type === 'form') {
            handleTargetForm(targetId);
            clearErrors()
            return;
        }

        handleSubmitProject(targetId)
        clearErrors()
        
    }

    const handleOnchangeProject = async e => {
        let projectTargetSelected = e.target.dataset.value;
        if (!projectTargetSelected || projectTargetSelected === projectTarget) {
            return;
        }

        if (draftModeData.isDraftMode) {
            let ticketId = draftTicketData?.detailTicket?.id;
            let currentStatusTicket = await checkDetailTicket(props?.API, ticketId);
            if (currentStatusTicket.status === Constant.TICKET_DELETED_STATUS.REMOVED) {
                setIsOpenPopupError(true);
                return;
            }
        }

        if ((draftModeData.isDraftMode && draftModeData.firstTimeUpdate) || 
            (isEdited && projectTarget)
        ) {
            setConfirmDialogObj({
                open: true,
                msg: I18n.get('USER04MSG016'),
                targetId: projectTargetSelected
            });
            setIsOpenSelectProject(false)
            return;
        }
        setIsOpenSelectProject(false)
        handleSubmitProject(projectTargetSelected);
        
    };

    const handleSubmitProject = async (projectTargetSelected) => {
        setIsLoading(true);
        setIsEdited(false);
        setProjectTarget(projectTargetSelected);
        setValueCreateEscalateTicket('projectTarget', projectTargetSelected);
        const selectedHelpDeskProjectDetail = listProjectDeskOn.find(
            project => project.id === projectTargetSelected
        );
        setValueCreateEscalateTicket(
            'corporationTarget',
            selectedHelpDeskProjectDetail.affiliationOrganization
        );
        setCorporationTarget(selectedHelpDeskProjectDetail.affiliationOrganization);
        const formOfProjectList = await getFormListByProject(
            props?.API,
            selectedHelpDeskProjectDetail.affiliationOrganization,
            projectTargetSelected
        );

        let listFormQaOfProject = formOfProjectList.filter(
            form => form.type === Constant.FORM_TYPE.FORM_REQ_QA
        );
        listFormQaOfProject = sortListByOrder(listFormQaOfProject, projectTargetSelected);

        setFormList(listFormQaOfProject);
        setSelectedForm('');
        setValueCreateEscalateTicket('selectedForm', '');
        setFiledListData([]);
        setIsLoading(false);
    }


    const handleCreateEscalateTicket = (formData, ticketStatus) => {
        if (Utils.isEmptyString(formData.projectTarget)) {
            setErorsCreateEscalateTicket(
                'projectTarget',
                { type: 'manual', message: I18n.get('COMM01MSG11') },
                { shouldFocus: false }
            );
            return;
        }
        if (Utils.isEmptyString(formData.selectedForm)) {
            setErorsCreateEscalateTicket(
                'selectedForm',
                { type: 'manual', message: I18n.get('COMM01MSG11') },
                { shouldFocus: false }
            );
            return;
        }
        return onSubmitCreateEscalateTicket(argsAll, ticketStatus, formData, fieldListData);
    };

    const handleSubmitSaveDraft = () => {
        let formData = getValueEscalateTicket();
        let isExistUrlError = isDataInputUrlError(fieldListData, errorCreateEscalateTicket);
        if (isExistUrlError) {
            return;
        }
        return onSubmitSaveDraftEscalateTicket(
            argsAll,
            formData,
            props.panelId,
            props.panelType,
            props.tabId
        );
    };

    useEffect(() => {
        setIsDisableButtonDraft(checkIsDisableButtonDraft(argsAll));
        setIsDisableButtonSent(checkIsDisableBtnSent(argsAll));
    });

    const handleSubmitDeleteDraft = () => {
        return onSubmitDeleteDraftQaTicket(
            argsAll,
            props.panelId,
            props.panelType,
            props.tabId
        );
    }

    const onCloseConfirmDialog = () => {
        setConfirmDialog({open: false, msg: ''})
    }

    const onOkConfirmDialog = () => {
        setConfirmDialog({open: false, msg: ''});
        handleSubmitDeleteDraft();
    }

    const onClickDelete = () => {
        setConfirmDialog({open: true, msg: I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT-ON-TICKET-LIST')})
    }

    const initDataLastForm = async (lastFormOfProject) => {
        setIsLoading(true);
        // Render width last QA form
        let lastFormQAOfProject = lastFormOfProject[Constant.TYPE_LAST_FORM.LAST_FORM_QA];
        if (!Utils.isEmptyObject(lastFormQAOfProject)) {
            // Validate Project
            let projectTargetDetail = await getProjectById(props?.API, lastFormQAOfProject?.projectTargetId);
            if (Utils.isEmptyObject(projectTargetDetail) || projectTargetDetail?.active === Constant.ACTIVE_FLAG.ACTIVE_FLAG || !projectTargetDetail?.isDesk) {
                return;
            }

            let listFormQAOfSelectedProject = await getFormListByProject(props?.API, lastFormQAOfProject?.corpTargetId, lastFormQAOfProject?.projectTargetId);
            setProjectTarget(lastFormQAOfProject.projectTargetId);
            setCorporationTarget(lastFormQAOfProject.corpTargetId);
            setValueCreateEscalateTicket('projectTarget', lastFormQAOfProject.projectTargetId);
            setValueCreateEscalateTicket('corporationTarget', lastFormQAOfProject.corpTargetId);

            let listFormQaOfProject = listFormQAOfSelectedProject.filter(
                form => form.type === Constant.FORM_TYPE.FORM_REQ_QA
            );
            listFormQaOfProject = sortListByOrder(listFormQaOfProject, lastFormQAOfProject.projectTargetId);

            setFormList(listFormQaOfProject);

            // Validate Form
            let selectedFormDetail = await getFormFromFormListById(lastFormQAOfProject.formId);
            if (Utils.isEmptyObject(selectedFormDetail) || !selectedFormDetail.usingProjects.includes(lastFormQAOfProject?.projectTargetId)) {
                return;
            }

            setValueCreateEscalateTicket('selectedForm', '');
            setValueCreateEscalateTicket('fileUploadList', []);
            setFiledListData([]);
            setSelectedForm(lastFormQAOfProject.formId);
            setSelectedFormInfo(selectedFormDetail);
            let e = {
                target: {
                    dataset: {
                        value: lastFormQAOfProject.formId
                    }
                }
            }
            await handleOnchangeForm(lastFormQAOfProject.formId, e);
        }
    }

    const displayOptionsByTicketType = () => {
        if (MAIL_TICKET_TYPES.includes(ticketDetail?.ticketType)) return false;
        return true;
    };

    const displayLabelByTicketType = () =>{ 
        if (MAIL_TICKET_TYPES.includes(ticketDetail?.ticketType))
            return I18n.get('LABEL-ESCALATE-SHARE-MAIL-TICKET');
        
        return I18n.get('LABEL-ESCALATE-SHARE-TICKET')
    }

    return (
        <div className="groupCreate-main">
            <LoadingPanel isLoading={isLoading} />
            <ButtonSubmitAddTicket
                ticketType={Constant.TICKET_TYPE.ESCALATION}
                onClickDraft={handleSubmitSaveDraft}
                onClick={handleSubmitCreateEscalateTicket(handleCreateEscalateTicket)}
                onClickDelete={onClickDelete}
                isEnableButtonDelete={isDraftMode}
                isDisableButtonDraft={isDisableButtonDraft}
                isDisableButtonSent={isDisableButtonSent}
                {...argsAll}
                isEdited={isEdited}
            />
            <div className="scrollBar-main">
                <div className="addTicket">
                    <div className="customerCheckbox">
                        <label className="customerCheckbox-label">
                            {I18n.get('LABEL-ESCALATE-SHARE-RESPONSE-TICKET')}
                        </label>
                        <FormGroup className="groupCheckBox">
                            {displayOptionsByTicketType() && (
                                <>
                                    <div className="itemCheckBox">
                                        <FormControlLabel
                                            className="custom-checkbox"
                                            checked={isEnableShareCustomerThread}
                                            control={
                                                <Checkbox
                                                    onChange={e => {
                                                        setIsEnableShareCustomerThread(
                                                            !isEnableShareCustomerThread
                                                        );
                                                        setIsEdited(true);
                                                    }}
                                                    color="primary"
                                                />
                                            }
                                            label={I18n.get('LABEL-ESCALATE-SHARE-RESPONSE-CHAT')}
                                        />
                                    </div>
                                </>
                            )}
                            <div className="itemCheckBox">
                                <FormControlLabel
                                    className="custom-checkbox"
                                    checked={isEnableShareTicketParent}
                                    control={
                                        <Checkbox
                                            onChange={e => {
                                                setIsEnableShareTicketParent(
                                                    !isEnableShareTicketParent
                                                );
                                                setIsEdited(true);
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label={displayLabelByTicketType()}
                                />
                            </div>
                        </FormGroup>
                    </div>
                    <FormProvider {...validateCreateEscalateTicket}>
                        <div className="form-addTicket">
                            <label className="form-addTicket-label">問い合わせ先デスク</label>
                            <div className="form-addTicket-input">
                                <FormInput
                                    className="form-control--wrap form-control--hg40"
                                    select
                                    variant="outlined"
                                    name="projectTarget"
                                    value={projectTarget}
                                    // onClick={e => handleOnchangeProject(e)}
                                    errorlist={errorCreateEscalateTicket}
                                    required
                                    inputProps={{
                                        readOnly: Utils.isProjectGuest(projectDetail)
                                    }}
                                    SelectProps={{
                                        value: projectTarget,
                                        open: isOpenSelectProject,
                                        onClose: e => setIsOpenSelectProject(false),
                                        onOpen: e => setIsOpenSelectProject(true),
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            },
                                            getContentAnchorEl: null,
                                            className: 'selectDrop'
                                        }
                                    }}
                                    // SelectProps={{
                                    //     MenuProps: {
                                    //         anchorOrigin: {
                                    //             vertical: 'bottom',
                                    //             horizontal: 'left'
                                    //         },
                                    //         getContentAnchorEl: null,
                                    //         className: 'selectDrop'
                                    //     }
                                    // }}
                                >
                                    {!Utils.isEmptyArray(internalHelpDeskList) && (
                                        <ListSubheader
                                            className="fontw-bold select-item-escalate-ticket"
                                            color="inherit"
                                            disableSticky
                                            onClickCapture={e => e.stopPropagation()}
                                        >
                                            {I18n.get('USER04BTN007')}
                                        </ListSubheader>
                                    )}
                                    {internalHelpDeskList && internalHelpDeskList.length > 0 ? (
                                        internalHelpDeskList?.map(item => {
                                            if (
                                                item.id !== localStorageUtil.getSelectedProjectId()
                                            ) {
                                                return (
                                                    <Tooltip
                                                        key={item.id + 'internal'}
                                                        value={item.id}
                                                        title={item.name}
                                                        placement="top"
                                                        arrow
                                                        interactive
                                                        onClickCapture={e => {
                                                            handleOnchangeProject(e);
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <MenuItem
                                                            key={item.id}
                                                            name={item.affiliationOrganization}
                                                            value={item.id}
                                                        >
                                                            {item.name}
                                                        </MenuItem>
                                                    </Tooltip>
                                                );
                                            }
                                        })
                                    ) : (
                                        <MenuItem style={{ display: 'none' }}></MenuItem>
                                    )}
                                    {!Utils.isEmptyArray(externalHelpDeskList) && (
                                        <ListSubheader
                                            className="fontw-bold select-item-escalate-ticket"
                                            color="inherit"
                                            disableSticky
                                            onClickCapture={e => e.stopPropagation()}
                                        >
                                            {I18n.get('USER04BTN008')}
                                        </ListSubheader>
                                    )}
                                    {externalHelpDeskList && externalHelpDeskList.length > 0 ? (
                                        externalHelpDeskList?.map(item => {
                                            if (
                                                item.id !== localStorageUtil.getSelectedProjectId()
                                            ) {
                                                return (
                                                    <Tooltip
                                                        key={item.id + 'external'}
                                                        value={item.id}
                                                        title={item.name}
                                                        placement="top"
                                                        arrow
                                                        interactive
                                                        onClickCapture={e => {
                                                            handleOnchangeProject(e);
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <MenuItem
                                                            key={item.affiliationOrganization}
                                                            name={item.affiliationOrganization}
                                                            value={item.id}
                                                        >
                                                            {item.name}
                                                        </MenuItem>
                                                    </Tooltip>
                                                );
                                            }
                                        })
                                    ) : (
                                        <MenuItem style={{ display: 'none' }}></MenuItem>
                                    )}
                                </FormInput>
                            </div>
                        </div>
                        <div className="form-addTicket">
                            <label className="form-addTicket-label">フォーマット</label>
                            <div className="form-addTicket-input">
                                <FormInput
                                    className="form-control--wrap form-control--hg40"
                                    select
                                    variant="outlined"
                                    name="selectedForm"
                                    value={selectedForm}
                                    defaultValue={selectedForm ? selectedForm : ''}
                                    // onClickCapture={e => handleOnchangeForm(e.target.dataset.value, e)}
                                    required
                                    errorlist={errorCreateEscalateTicket}
                                    SelectProps={{
                                        value: selectedForm,
                                        open: isOpenSelectForm,
                                        onClose: e => setIsOpenSelectForm(false),
                                        onOpen: e => setIsOpenSelectForm(true),
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            },
                                            getContentAnchorEl: null,
                                            className: 'selectDrop'
                                        }
                                    }}
                                >
                                    {!Utils.isEmptyArray(formList) &&
                                        formList?.map(item => {
                                            return (
                                                <Tooltip
                                                    title={Utils.getTextByLanguage(
                                                        Constant.LANGUAGE_TYPE.JP,
                                                        item.name
                                                    )}
                                                    key={item.id}
                                                    value={item.id}
                                                    data-cy="qa-ticket-item-form"
                                                    className="select-item"
                                                    onClickCapture={e =>
                                                        handleOnchangeForm(
                                                            e.target.dataset.value,
                                                            e
                                                        )
                                                    }
                                                >
                                                    <MenuItem key={item.id} value={item.id}>
                                                        {Utils.getTextByLanguage(
                                                            Constant.LANGUAGE_TYPE.JP,
                                                            item.name
                                                        )}
                                                    </MenuItem>
                                                </Tooltip>
                                            );
                                        })}
                                </FormInput>
                            </div>
                        </div>
                        {!Utils.isEmptyArray(fieldListData) &&
                            fieldListData
                                ?.filter(field => field.type !== Constant.FORM_TYPE.FIELD_WORKFLOW)
                                .map((fieldData, i) => (
                                    <RenderFieldUI
                                        API={props?.API}
                                        UI={fieldData.structure.UI}
                                        label={
                                            fieldData.fieldLabel
                                                ? Utils.getTextByLanguage(
                                                      Constant.LANGUAGE_TYPE.JP,
                                                      fieldData.fieldLabel
                                                  )
                                                : ''
                                        }
                                        errorlist={errorCreateEscalateTicket}
                                        key={`field-${fieldData.fieldId}`}
                                        name={fieldData.fieldId}
                                        data={fieldData}
                                        defaultValue={
                                            currentPanelInitData.formData &&
                                            currentPanelInitData.formData[fieldData.fieldId]
                                                ? currentPanelInitData.formData[fieldData.fieldId]
                                                : null
                                        }
                                        // Drop file props
                                        editTicket={
                                            Utils.isEmptyObject(props?.draftData) ? false : true
                                        }
                                        isDraft={
                                            Utils.isEmptyObject(props?.draftData) ? false : true
                                        }
                                        fileUploadList={fileUploadList}
                                        setFileUploadList={setFileUploadList}
                                        register={registerCreateEscalateTicket}
                                        setValue={setValueCreateEscalateTicket}
                                        clearErrors={clearErrors}
                                        parentForm={selectedFormInfo}
                                        autoFillObject={autoFillObject}
                                        setAutoFillObject={setAutoFillObject}
                                        isExChangeTagField={isExChangeTagField}
                                        setIsExChangeTagField={setIsExChangeTagField}
                                        listFieldEdited={listFieldEdited}
                                        setListFieldEdited={setListFieldEdited}
                                        isEdited={isEdited}
                                        setIsEdited={setIsEdited}
                                        fileUpdatedList={fileUpdatedList}
                                        setFileUpdatedList={setFileUpdatedList}
                                        detailTicket={props?.detailTicket}
                                        isLoading={isLoading}
                                        setIsLoading={setIsLoading}
                                        isShowIconCopyFieldId={false}
                                        onClickUrlViewTicket={onClickUrlViewTicket}
                                        panelId={props.panelId}
                                        tabId={props.tabId}
                                        panelInitData={panelInitData}
                                        setPanelInitData={setPanelInitData}
                                        setOnChangeEdit={setOnChangeEdit}
                                        onChangeEdit={onChangeEdit}
                                        panelList={panelList}
                                    />
                                ))}
                    </FormProvider>
                </div>
            </div>

            <DataChangePleaseReloadModal
                {...argsAll}
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />

            <DialogConfirmCancelCreateTicket
                {...argsAll}
                onClickSaveDraft={handleSubmitSaveDraft}
                handleSubmitSentDraft={handleSubmitCreateEscalateTicket(data =>
                    handleCreateEscalateTicket(data)
                )}
                isDisableButtonSend={isDisableButtonSent}
                setErrorCreateTicket={setErorsCreateEscalateTicket}
                getValuesCreateTicket={getValueEscalateTicket}
                fieldListData={fieldListData}
            />

            <ErrorModal
                open={isModalUploadFileError}
                message={`${fileUploading?.file?.name} ${I18n.get('USER04MSG004')}`}
                handleCloseDialog={() => setIsModalUploadFileError(false)}
                title={'Upload fail'}
            ></ErrorModal>

            <ConfirmDialog
                isOpen={confirmDialogObj.open}
                msgConfirm={confirmDialogObj?.msg}
                closeCallBack={onClickCloseConfirmDialog}
                okCallBack={onClickOkConfirmDialog}
            />
            <ConfirmDialog
                isOpen={confirmDialog.open}
                msgConfirm={confirmDialog?.msg}
                closeCallBack={onCloseConfirmDialog}
                okCallBack={onOkConfirmDialog}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />

            <ConfirmDialog
                isOpen={isOpenPopupKnowledgeOff}
                msgConfirm={I18n.get('USER14MSG028')}
                okCallBack={e => {
                    setIsOpenPopupKnowledgeOff(false);
                }}
                textSubmit={'はい'}
            />
            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={I18n.get('KNOWDEMSG005')}
                okCallBack={e => setIsOpenAccessDeniedPopup(false)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={isOpenNotFoundTicketPopup}
                msgConfirm={I18n.get('MSG-CM-DELETED-CONTENT')}
                okCallBack={e => setIsOpenNotFoundTicketPopup(false)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={showPopupSingleButtonError?.isShow}
                msgConfirm={showPopupSingleButtonError?.message}
                okCallBack={e =>
                    setShowPopupSingleButtonError(pre => {
                        return {
                            ...pre,
                            isShow: false
                        };
                    })
                }
                textSubmit={showPopupSingleButtonError?.confirmTxt}
            />
            <DialogConfirmChangeTicketError {...argsAll} isOpen={isOpenPopupError} />
        </div>
    );
}
